var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.871A6.586 6.586 0 00.875 7 6.586 6.586 0 007 11.129 6.586 6.586 0 0013.125 7 6.586 6.586 0 007 2.871zm0 6.883c-1.531 0-2.784-1.24-2.784-2.754C4.216 5.485 5.47 4.246 7 4.246S9.784 5.486 9.784 7C9.784 8.515 8.53 9.754 7 9.754zm0-4.406c-.919 0-1.67.744-1.67 1.652 0 .908.751 1.652 1.67 1.652.919 0 1.67-.744 1.67-1.652 0-.908-.751-1.652-1.67-1.652z",
    fill: "#F59E0B"
  })));
}
export default SvgEye;